import { render, staticRenderFns } from "./step_2.vue?vue&type=template&id=0b2b1ddd&scoped=true&"
import script from "./step_2.vue?vue&type=script&lang=js&"
export * from "./step_2.vue?vue&type=script&lang=js&"
import style0 from "./step_2.vue?vue&type=style&index=0&id=0b2b1ddd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b1ddd",
  null
  
)

export default component.exports